import * as yup from 'yup';
import { CheckboxValueSchema } from '../../../common';

export const MaterialApplicationSchema = yup.object({
  material: yup.string().required(),
  application: yup.string().required(),
});

export const WoundTherapySchema = yup.object({
  // TODO: Create therapy schema
  intervalNumber: yup.number().nullable(),
  weekdays: CheckboxValueSchema.nullable(),
  materialApplications: yup.array().of(MaterialApplicationSchema).notRequired().nullable(),
  startDate: yup
    .date()
    .required()
    .default(() => new Date()),
  interval: yup.string().required(),
  startPrescribedVerbal: yup.boolean().default(false),
  // TODO: Use doctor id
  startedById: yup.string().required(),
  discharged: yup.boolean().default(false),
  dischargeDate: yup.mixed<Date | undefined>().when('discharged', {
    is: true,
    then: yup
      .date()
      .required()
      .default(() => new Date()),
    otherwise: yup.mixed().oneOf([null]),
  }),
  dischargePrescribedVerbal: yup.mixed<boolean | null>().when('discharged', {
    is: true,
    then: yup.boolean().default(false),
    otherwise: yup.mixed().oneOf([false]),
  }),
  dischargedById: yup.mixed<string | undefined>().when('discharged', {
    is: true,
    // TODO: Use doctor id
    then: yup.string().required(),
    otherwise: yup.mixed().oneOf([null]),
  }),
});

export type IWoundTherapy = yup.InferType<typeof WoundTherapySchema>;

export const WoundTherapyCreateSchema = yup
  .object({
    residentId: yup.string().required(),
  })
  .concat(WoundTherapySchema);
export interface IWoundTherapyCreate extends IWoundTherapy {
  residentId: string;
}

export const WoundTherapyUpdateSchema = yup.object({
  id: yup.string().required(),
  discharged: yup.boolean().default(false),
  dischargeDate: yup.mixed<Date | undefined>().when('discharged', {
    is: true,
    then: yup
      .date()
      .required()
      .default(() => new Date()),
    otherwise: yup.mixed().oneOf([null]),
  }),
  dischargePrescribedVerbal: yup.mixed<boolean>().when('discharged', {
    is: true,
    then: yup.boolean().default(false),
    otherwise: yup.mixed().oneOf([false]),
  }),
  dischargedById: yup.mixed<string | undefined>().when('discharged', {
    is: true,
    // TODO: Use doctor id
    then: yup.string().required(),
    otherwise: yup.mixed().oneOf([null]),
  }),
  nursingTaskId: yup.string().nullable(),
});

export type IWoundTherapyUpdate = yup.InferType<typeof WoundTherapyUpdateSchema>;
